"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var queryContext_1 = require("../../context/queryContext/queryContext");

exports.useQueryContext = function () {
  var context = react_1.useContext(queryContext_1.QueryContext);

  if (context === undefined) {
    throw new Error('useQueryContext must be used within a QueryContext.Provider');
  }

  return context;
};